import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-splash',
  templateUrl: './intro-splash.component.html',
  styleUrls: ['./intro-splash.component.scss']
})
export class IntroSplashComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
